import { Injectable } from "@angular/core";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { ICategoryTicket, ICategoryTicketForm, IMeTicket, ITicket, ITicketSingle } from "./models/tickets";

@Injectable({
  providedIn: "root",
})
export class TicketService {
  public list: ITicket[] = [];
  public singleReport: ITicketSingle;
  public mineTicket: IMeTicket[];
  public baseUrl: string = "/ticket";
  public categoriesList: ICategoryTicket[] = [];
  public baseUrlCategories: string = "/ticket-category";

  constructor(public _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get(this.baseUrl)
      .toPromise()
      .then((response: ITicket[]) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async getMineTicket() {
    return this._httpClient
      .get("/me/ticket")
      .toPromise()
      .then((response: IMeTicket[]) => {
        this.mineTicket = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async get(id: number) {
    return this._httpClient
      .get<ITicketSingle | {}>(this.baseUrl + "/" + id)
      .toPromise()
      .then((response: ITicketSingle) => {
        this.singleReport = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return null;
      });
  }

  async create(data: { title: string; category: number; note: string }) {
    return this._httpClient.post(this.baseUrl, data).toPromise();
  }

  async update(id: number, data) {
    return this._httpClient.put(this.baseUrl + "/" + id, data).toPromise();
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseUrl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getMineTicket();
        return response;
      });
  }

  async deleteTicket(id: number) {
    return this._httpClient.delete(`${this.baseUrl}/${id}`).toPromise();
  }

  async updateStatus(data: { ticket_id: number; status: number; response?: string }) {
    return this._httpClient
      .post("/ticket/status", data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      })
      .catch((error) => {
        console.error(error);
        return error;
      });
  }

  //Categorie Ticket
  async getCategoriesList(all: boolean = false) {
    return this._httpClient
      .get(this.baseUrlCategories + (all ? "?all=1" : ""))
      .toPromise()
      .then((response: ICategoryTicket[]) => {
        this.categoriesList = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async deleteCategory(id: number) {
    return this._httpClient
      .delete(this.baseUrlCategories + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getCategoriesList();
        return response;
      });
  }

  async createCategory(data: ICategoryTicketForm) {
    return this._httpClient
      .post(this.baseUrlCategories, data)
      .toPromise()
      .then(async (response) => {
        await this.getCategoriesList();
        return response;
      });
  }

  async updateCategory(id: number, data: ICategoryTicketForm) {
    return this._httpClient
      .put(this.baseUrlCategories + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getCategoriesList();
      });
  }

  async uploadFile(file, id: number, closure: boolean) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: HttpRequest<FormData> = new HttpRequest("PUT", `/ticket/${id}/${closure}`, formData);
    return this._httpClient.request(req).toPromise();
  }

  async deleteAttachment(id: number) {
    return this._httpClient.delete("/ticket/attachment/" + id).toPromise();
  }
}
